/**
 * @file AddBtn
 */

'use strict';
import Common from '../../Utils/Common';

/**
 * @classname WarningModal
 * @classdesc WarningModal
 */
export default class WarningModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log(`WarningModal.constructor`);
		if ($e.val() === '1') Common.showWarningModal('<p class="text text-danger fwb">続いて次の画面で非加盟員の本申請をお願いします。</p><p class="text">※登録料計算表は本申請分(非加盟員のみ)を計上します</p><p class="text">※加盟員は仮申請されました</p>');
	};
}
